import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lovers-pontos',
  templateUrl: './pontos.component.html',
  styleUrls: ['./pontos.component.scss'],
})
export class PontosComponent implements OnInit {
  @Input() public pontuacao: number = 0;
  @Input() public minimo: boolean = false;
  @Input() public bordaDiferente: boolean = false;
  @Input() public botaoCard: boolean = false;
  @Input() public exibirVoceTem: boolean = true;
  @Input() public tipo: string = 'padrao';
  @Input() public redirectExtrato: boolean = false;
  @Input() public experienciaCard: boolean = false;

  public pontosClasse: string = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.definirClassePontos();
  }

  definirClassePontos(): string {
    let classe = '';

    if (this.minimo) classe += 'pontos--minimo ';

    if (this.bordaDiferente) classe += 'pontos--borda--diferente ';

    if (this.botaoCard) classe += 'pontos--card ';

    if (this.experienciaCard) classe += 'pontos--experiencia-card ';

    if (this.exibirVoceTem) classe += 'pontos--resumo ';

    switch (this.tipo) {
      case 'experiencia':
        classe += 'pontos--experiencia ';
        break;

      default:
        classe += 'padrao ';
    }

    if (this.redirectExtrato) classe += 'clicavel ';

    return classe;
  }

  onClick() {
    if (!this.redirectExtrato) return;
    this.router.navigate(['/extrato']);
  }
}
